function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m504.583 271.251c-4.682-5.527-11.065-9.198-18.057-10.508l-12.986-44.317c-3.358-11.459-14.042-19.462-25.98-19.462h-314.319c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h314.319c5.324 0 10.088 3.57 11.586 8.681l13.763 46.968-24.316 76.16c-4.462-8.348-13.265-14.04-23.373-14.04h-150.328c-7.437 0-14.168 3.082-18.983 8.035-4.815-4.953-11.546-8.035-18.983-8.035h-150.153c-10.108 0-18.912 5.693-23.374 14.041l-24.316-76.16 13.764-46.968c1.498-5.111 6.262-8.681 11.585-8.681h33.919c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-33.918c-11.938 0-22.622 8.003-25.98 19.463l-12.987 44.317c-6.993 1.311-13.375 4.981-18.057 10.509-5.949 7.022-8.494 16.257-6.982 25.336l17.28 103.754c4.351 26.123 25.148 45.71 50.799 48.936v39.219c0 4.142 3.358 7.5 7.5 7.5h28.221c2.991 0 5.695-1.777 6.883-4.521l18.058-41.729h164.691c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-217.853c-21.649 0-39.945-15.506-43.503-36.869l-17.28-103.754c-.786-4.722.537-9.524 3.631-13.176 1.932-2.281 4.42-3.953 7.182-4.887l34.61 108.402c.992 3.108 3.881 5.219 7.145 5.219h376.413c3.264 0 6.152-2.11 7.145-5.219l34.61-108.402c2.762.934 5.25 2.606 7.182 4.887 3.094 3.651 4.417 8.454 3.631 13.176l-17.28 103.754c-3.558 21.363-21.854 36.869-43.503 36.869h-106.946c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h48.681l18.058 41.729c1.188 2.745 3.893 4.521 6.883 4.521h28.221c4.143 0 7.5-3.358 7.5-7.5v-38.798c27.957-1.109 51.265-21.522 55.9-49.357l17.28-103.754c1.512-9.082-1.032-18.317-6.983-25.339zm-421.077 178.496h29.317l-13.523 31.25h-15.794zm164.903-75.066h-173.119v-18.467c0-6.332 5.151-11.483 11.483-11.483h150.153c6.332 0 11.483 5.151 11.483 11.483zm188.293 0h-173.293v-18.467c0-6.332 5.151-11.483 11.482-11.483h150.329c6.331 0 11.482 5.151 11.482 11.483zm-13.316 106.316h-15.794l-13.523-31.25h29.317z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m152.414 171.986h206.99c4.143 0 7.5-3.358 7.5-7.5v-37.646c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v30.146h-191.99v-125.989h191.99v60.991c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-68.491c0-4.142-3.357-7.5-7.5-7.5h-206.99c-4.142 0-7.5 3.358-7.5 7.5v140.989c0 4.142 3.358 7.5 7.5 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182.437 46.029c-4.142 0-7.5 3.358-7.5 7.5v80.924c0 4.142 3.358 7.5 7.5 7.5h146.945c4.143 0 7.5-3.358 7.5-7.5v-80.924c0-4.142-3.357-7.5-7.5-7.5zm139.445 80.924h-131.945v-8.292l25.227-27.887 24.282 19.728c2.526 2.053 6.09 2.241 8.819.465l19.45-12.654 54.168 22.224v6.416zm0-22.63-52.114-21.381c-2.278-.934-4.873-.69-6.937.652l-18.167 11.82-25.563-20.768c-3.094-2.514-7.616-2.167-10.291.79l-18.874 20.864v-35.271h131.945v43.294z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133.346,
  cy: 245.685,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 214.376,
  cy: 245.685,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173.856,
  cy: 296.157,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 254.886,
  cy: 296.16,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.447,
  cy: 245.68,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 337.882,
  cy: 296.167,
  r: 7.485
}), /*#__PURE__*/React.createElement("circle", {
  cx: 378.491,
  cy: 245.687,
  r: 7.485
}));

function SvgSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.994 511.994",
    height: 512,
    viewBox: "0 0 511.994 511.994",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.6a4122ea.svg";
export { ForwardRef as ReactComponent };